// extracted by extract-css-chunks-webpack-plugin
module.exports = {"active":"search-button__active__3AmNj"};